import{a as f}from"./chunk-MU4WOLM6.mjs";import{a as p,b as t}from"./chunk-VTRYZJDB.mjs";import{applyBoxStyles as n}from"@refract-ui/core";import{jsx as s}from"react/jsx-runtime";var u=t.css`
  ${({theme:{elements:e,box:r}})=>Object.keys(e).filter(o=>e[o]).map(o=>{let m=n(r,e[o]);return o==="body"?m:t.css`
            ${o} {
              ${m}
            }
          `})}
`,y=p(f)`
  ${u}
`,h=({theme:e,...r})=>e?s(t.ThemeProvider,{theme:e,children:s(y,{...r})}):s(y,{...r}),b=h;export{u as a,y as b,b as c};
